import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function SharedSearch() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/saved-searches/${token}`)
      .then((r) => setSearch(r.data))
      .catch(() => setError("This shared search no longer exists."));
  }, [token]);

  useEffect(() => {
    if (search) {
      const sp = new URLSearchParams();
      Object.entries(search.filters || {}).forEach(([k, v]) => v && sp.set(k, v));
      navigate(`/tracker?${sp.toString()}`, { replace: true });
    }
  }, [search, navigate]);

  if (error) return (
    <div className="max-w-[700px] mx-auto px-6 py-20 text-center">
      <h1 className="font-display text-3xl font-bold">{error}</h1>
      <Link to="/tracker"><Button className="rounded-none bg-black text-white mt-6">Go to tracker</Button></Link>
    </div>
  );
  return <div className="max-w-[700px] mx-auto px-6 py-20 text-center font-mono-plex uppercase tracking-wider text-sm">Loading shared view…</div>;
}
